if (!customElements.get('product-daily-deal')) {
  const cardData = window.NUTRILAND_DAILY_DEAL;
  const cardProductIds = new Set(cardData?.enabled === true ? cardData.productIds : []);
  const deals = new Set();
  let interval;

  const stopWhenEmpty = () => {
    if (!deals.size) {
      clearInterval(interval);
      interval = undefined;
    }
  };

  const updateDeals = () => {
    const now = Date.now();
    deals.forEach(deal => deal.update(now));
  };

  class ProductDailyDeal extends HTMLElement {
    connectedCallback() {
      this.init();
    }

    init() {
      this.card?.classList.remove('product-item--daily-deal');
      this.card = this.isCard ? this.closest('.product-item') : null;
      this.expiresAt = this.isCard
        ? cardData?.expiresAt
        : Number(this.dataset.expiresAt);
      this.timer = this.querySelector('[role="timer"]');
      this.hours = this.querySelector('[data-deal-hours]');
      this.minutes = this.querySelector('[data-deal-minutes]');
      this.seconds = this.querySelector('[data-deal-seconds]');

      if (this.isCard && (this.dataset.available !== 'true' || !cardProductIds.has(this.dataset.productId))) {
        this.deactivate();
        return;
      }

      this.hidden = this.isCard && this.hasAttribute('data-highlight-only');
      this.card?.classList.add('product-item--daily-deal');
      deals.add(this);
      this.update(Date.now());
      if (deals.size && interval === undefined) {
        interval = setInterval(updateDeals, 1000);
      }
    }

    disconnectedCallback() {
      deals.delete(this);
      this.card?.classList.remove('product-item--daily-deal');
      stopWhenEmpty();
    }

    deactivate() {
      this.card?.classList.remove('product-item--daily-deal');
      if (this.isCard) this.hidden = true;
      else this.remove();
      deals.delete(this);
      stopWhenEmpty();
    }

    update(now) {
      const distance = this.expiresAt - now;
      if (!Number.isFinite(distance) || distance <= 0) {
        this.deactivate();
        return;
      }

      const remaining = Math.floor(distance / 1000);
      if (this.timer) {
        this.updateDigits(this.hours, Math.floor(remaining / 3600));
        this.updateDigits(this.minutes, Math.floor(remaining % 3600 / 60));
        this.updateDigits(this.seconds, remaining % 60);
        this.timer.classList.remove('hide');
      }
    }

    updateDigits(element, value) {
      if (!element) return;
      const digits = String(value).padStart(2, '0');
      if (element.textContent !== digits) {
        element.innerHTML = `<span>${digits[0]}</span><span>${digits[1]}</span>`;
      }
    }
  }

  class ProductDailyDealCard extends ProductDailyDeal {
    get isCard() {
      return true;
    }

    static get observedAttributes() {
      return ['data-product-id', 'data-available'];
    }

    attributeChangedCallback(name, previous, next) {
      if (previous !== next && this.isConnected) this.init();
    }
  }

  customElements.define('product-daily-deal', ProductDailyDeal);
  customElements.define('product-daily-deal-card', ProductDailyDealCard);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateDeals();
  });
  window.addEventListener('pageshow', updateDeals);
}
